import { createContext } from 'react'

import type { SCAContextType } from './types'

export const SCAContext = createContext<SCAContextType | null>(null)
